import RelatorioFormulario from './RelatorioFormulario';
import { montarCalcularExtras } from './secoes-csv';

// Consulta das visitas da Avaliação de Treinamento (renomeada de "Avaliação
// TSV" em 2026-09-23 — rótulo apenas; tabela, rota e chaves internas
// continuam `dtbAvaliacaoTSV`/`/api/avaliacao`/`avaliacao-tsv`).
//
// A TELA está em RelatorioFormulario.js. ⚠️ Deixou de ser compartilhada com a
// Auditoria SA em 2026-09-23 (DEM-00011, T22/ajuste visual): a SA ganhou tela
// própria (AvaliacaoSAHistorico.js, no módulo Operacional) — este componente
// agora serve só a TSV, mas o nome do arquivo continua `RelatorioFormulario.js`
// porque outra reestruturação de nome no mesmo dia seria custo sem retorno.
// Desde 2026-08-05 a lista mostra uma linha por visita e o detalhe pergunta a
// pergunta virou o PDF (que traz as fotos das negativas); o CSV segue
// exportando as colunas de pergunta.

// Seções da TSV, por extenso. Cada uma soma as colunas PONT_ das suas perguntas.
// ⚠️ D3 NÃO EXISTE de propósito (buraco de numeração por desenho do formulário).
const SECOES = [
  { key: 'funcionarios', label: 'A - Funcionários', chaves: ['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8'] },
  { key: 'gerentes', label: 'B - Gerentes', chaves: ['B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9'] },
  { key: 'treinadores', label: 'C - Treinadores', chaves: ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10', 'C11'] },
  { key: 'operacional', label: 'D - Operacional', chaves: ['D1', 'D2', 'D4', 'D5', 'D6', 'D7', 'D8', 'D9', 'D10', 'D11', 'D12', 'D13', 'D14', 'D15', 'D16'] },
];

// Colunas do export CSV.
// ⚠️ Os rótulos das seções estavam ERRADOS até 2026-08-05: traziam os títulos da
// Auditoria SA ('Higiene e Limpeza', 'Armazenamento'…), herdados de quando este
// arquivo foi copiado do dela. Quem exportava a TSV recebia colunas com nome de
// outro formulário.
const colunasCsv = [
  { key: 'LOJA', label: 'Loja' },
  { key: 'DATA', label: 'Data' },
  { key: 'GERENTE_NEGOCIO', label: 'Gerente de Negócios' },
  { key: 'GERENTE_PLANTAO', label: 'Gerente de Plantão' },
  ...SECOES.map((s) => ({ key: s.key, label: s.label })),
  ...SECOES.flatMap((s) => s.chaves.map((c) => ({ key: `P_${c}`, label: `${c} — resposta` }))),
  ...SECOES.flatMap((s) => s.chaves.map((c) => ({ key: `OBS_${c}`, label: `${c} — observação` }))),
  { key: 'QTD_EVIDENCIAS', label: 'Evidências (fotos)' },
  { key: 'PORCENTAGEM_TOTAL', label: 'Porcentagem Total' },
  { key: 'STATUS', label: 'Status' },
  // Diz qual régua vale para a linha (T19) — sem isto o % de contagem (novo) e a
  // soma de pontos (legado) ficariam na mesma coluna de seção sem aviso.
  { key: 'METODO_LABEL', label: 'Método da nota' },
  // Quem enviou a visita. Vem vazio nas visitas anteriores ao registro do autor.
  { key: 'REGISTRADO_POR', label: 'Registrado por' },
];

// Colunas de seção do CSV: contagem pura (%) no método novo, soma de PONT_ no
// legado. A conta mora em secoes-csv.js.
const calcularExtras = montarCalcularExtras(SECOES);

function AvaliacaoRelatorio({ embedded = false }) {
  return (
    <RelatorioFormulario
      api="/api/avaliacao"
      titulo="Relatório da Avaliação de Treinamento"
      subtitulo="Consulte as visitas, abra o relatório em PDF (com as evidências) e exporte os dados."
      colunasCsv={colunasCsv}
      calcularExtras={calcularExtras}
      embedded={embedded}
    />
  );
}

export default AvaliacaoRelatorio;
